import ContentList from './ContentList';
import ContentCreate from './ContentCreate';
import ContentEdit from './ContentEdit';

export default {
  list: ContentList,
  create: ContentCreate,
  edit: ContentEdit,
};
